export default __webpack_public_path__ + "1e53b5afece15b2c54e36127121111fd.png";